import { SymbolAndOptionalExchangeCode } from '../../lib/models/fundamental/types';

export interface WatchListStocks extends SymbolAndOptionalExchangeCode {
  url?: string;
  companyName?: string;
}

export interface WatchListSortedStocks extends WatchListStocks {
  change: number;
  changePercent: number;
  currentPrice: number;
}

export enum WatchListHeaderEnum {
  COLUMN_LAST_PRICE = 2,
  COLUMN_CHANGE,
  COLUMN_PERCENT_CHANGE,
}

export enum WatchListSortingType {
  HighestPrice = 1,
  LowestPrice = 2,
  HighestChange = 3,
  LowestChange = 4,
}
